// Messages actions
import makePaginatedListActions from './paginated'

export const GET_MESSAGES = 'GET_MESSAGES'
export const [
  loadMessages,
  loadMoreMessages,
  unloadMessages,
] = makePaginatedListActions(GET_MESSAGES)

export const GET_MESSAGE = 'GET_MESSAGE'
export const GET_MESSAGE_LOADING = 'GET_MESSAGE_LOADING'
export const GET_MESSAGE_FAILURE = 'GET_MESSAGE_FAILURE'
export const GET_MESSAGE_SUCCESS = 'GET_MESSAGE_SUCCESS'
export const getMessage = id => ({
  type: GET_MESSAGE,
  payload: id,
})

export const MARK_MESSAGE_AS_READ = 'MARK_MESSAGE_AS_READ'
export const MARK_MESSAGE_AS_READ_LOADING = 'MARK_MESSAGE_AS_READ_LOADING'
export const MARK_MESSAGE_AS_READ_FAILURE = 'MARK_MESSAGE_AS_READ_FAILURE'
export const MARK_MESSAGE_AS_READ_SUCCESS = 'MARK_MESSAGE_AS_READ_SUCCESS'
export const markMessageAsRead = id => ({
  type: MARK_MESSAGE_AS_READ,
  payload: id,
})



// WEBPACK FOOTER //
// ./src/actions/messages.js